import { useContext, useMemo } from 'react'
import { Permissions, UserInfoContextType } from '../../React/Common/Contexts/UserInfoContext'
import { UserInfoContext } from '../../React/Common/Contexts'
import { IsVarEmpty } from '../../NonReact/utils/GlobalFunctions'
import { hasPermissions } from '../../React/Common/Utils/PermissionsUtil'

export const useCheckUserHasPermissions = (permissions: Permissions[], allowSome?: boolean): Definable<boolean> => {
    const userInfo: UserInfoContextType = useContext(UserInfoContext)

    return useMemo((): Definable<boolean> => {
        if (IsVarEmpty(userInfo)) {
            return undefined
        }

        return hasPermissions(userInfo, permissions, allowSome)
    }, [permissions, allowSome, userInfo])
}
